// redux
import { useSelector } from 'react-redux';
import { RootState } from '../../../store';
// LaTeX
import Latex from 'react-latex-next';
import Secciones from '../Secciones/Secciones';
import ModalDiapositiva from './Diapositivas/ModalDiapositiva';
// mui components

const Bloques = () => {

  const { bloques, isLoading } = useSelector((state: RootState) => state.bloque);

  if (isLoading) {
    return (
      <div className="d-flex justify-content-center">
        <div className="spinner-border text-success" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    )
  }

  return (
    <div>
      {
        bloques.map(item => {
          const { bid, nombre } = item;
          return (
            <div
              key={bid}
              className='card mb-4'
              style={{ boxShadow: '2px 2px 2px rgba(0, 0, 0, 0.3)' }}
            >
              <div className="card-header p-1 py-2">

                <div className="row justify-content-between align-items-center m-0">
                  <div className="col-auto">
                    <Latex>{`<span style="font-size:1em; font-weight: bold; color: #11387b"}}>${nombre}</span>`}</Latex>
                  </div>
                  <div className="col-auto">
                    <ModalDiapositiva bloque={item} />
                  </div>
                </div>

              </div>

              <Secciones bloque={item} />

            </div>
          )
        })
      }
    </div>
  )
}

export default Bloques;